import script from "./AccountComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountComponent.vue?vue&type=script&setup=true&lang=ts"

import "./AccountComponent.vue?vue&type=style&index=0&id=920e0f3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-920e0f3a"]])

export default __exports__